const REASONS = [
    { value: 'SPAM', label: 'Spam or scam' },
    { value: 'HARASSMENT', label: 'Harassment or bullying' },
    { value: 'HATE_SPEECH', label: 'Hate speech' },
    { value: 'NUDITY', label: 'Nudity or sexual content' },
    { value: 'FALSE_INFORMATION', label: 'Misinformation' },
    { value: 'OTHER', label: 'Other reasons' },
];

const ReportForm = ({ 
    reason, setReason, 
    description, setDescription, 
    errorMessage, isPending, 
    onSubmit, onCancel 
}) => {
    return (
        <form className="report-form" onSubmit={onSubmit}>
            <div className="form-group">
                <label className="group-label">
                    Please select the issue:
                </label>
                
                <div className="reason-list">
                    {REASONS.map((item) => (
                        <label key={item.value} className="reason-item">
                            <input
                                type="radio"
                                name="reason"
                                value={item.value}
                                checked={reason === item.value}
                                onChange={(e) => setReason(e.target.value)}
                            />

                            <span>
                                {item.label}
                            </span>
                        </label>
                    ))}
                </div>
            </div>

            <div className="form-group">
                <label className="group-label">
                    Additional description (Optional):
                </label>

                <textarea
                    rows="3"
                    placeholder="Providing more details will help administrators understand better..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                ></textarea>
            </div>

            {errorMessage && (
                <div className="error-msg">{errorMessage}</div>
            )}

            <div className="report-modal-footer">
                <button 
                    type="button" 
                    className="cancel-btn" 
                    onClick={onCancel}
                    disabled={isPending}
                >
                    Cancel
                </button>

                <button 
                    type="submit" 
                    className="submit-btn"
                    disabled={isPending}
                >
                    {isPending ? 'Sending...' : 'Submit report'}
                </button>
            </div>
        </form>
    );
};

export default ReportForm;